<template>
    <div class="code-box">
        <input ref="codeinput"
               v-model="inputdata"
               type="tel"
               pattern="[0-9]*"
               :maxlength="maxlength"
               class="code-input"
               @input="input()"
               @keyup.enter="inputBlur()">
        <div class="code-all" @click="focus" v-if="type === 'password'">
            <div class="code-item"
                 v-for="(item, index) in codeData"
                 :key="index"
                 :class="{'code-active': index === 0 || inputdata.length - 1 >= index, 'code-password': inputdata.length - 1 >= index }"
                 :style="[styles]"
                 contenteditable="true"></div>
        </div>
        <div class="code-all" @click="focus" v-else>
            <div class="code-item"
                 v-for="(item, index) in codeData"
                 :class="{'code-active': index === 0 || inputdata.length - 1 >= index }"
                 :key="index"
                 :style="[styles]"
                 contenteditable="true">{{item}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'VerificationCode',
    components: {},
    props: {
        type: {
            type: String,
            required: false,
            default: 'number'
        },
        maxlength: {
            type: Number,
            required: false,
            default: 4
        },
        styles: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            inputdata: '',
            codeData: []
        };
    },
    watch: {
        inputdata(newVal, oldVal) {
            // console.log("newVal", newVal)
            // console.log("oldVal", oldVal)
            // console.log("codeData", this.codeData)
            if (/[^\d]/g.test(newVal)) {
                this.inputdata = this.inputdata.replace(/[^\d]/g, '');
                return
            }
            if (newVal.length > this.maxlength) {
                this.inputdata = newVal.substr(0, this.maxlength)
            }
            for (let i = 0; i < this.maxlength; i++) {
                this.$data.codeData[i] = (i < newVal.length) ? newVal[i] : ''
            }
        },
    },
    mounted() {
        this.$refs.codeinput.focus();
        this.codeData = new Array(this.maxlength).fill('')
    },
    methods: {
        focus() {
            this.$refs.codeinput.focus();
        },
        input() {
            this.$emit('output', {
                data: this.$data.inputdata
            });
        }
    }
};
</script>
<style lang="scss" scoped>
// 激活样式
.code-active {
  border-bottom: 1px solid #333333 !important;
}

.code-box {
  width: 320px;
  margin: 30px auto 0;
  position: relative;
  overflow-x: hidden;

  & > .code-input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    border: none;
    color: transparent;
    caret-color: transparent;
    text-indent: -999em;
  }

  & > .code-all {
    padding: 5px;
    display: flex;
    align-content: space-between;

    & > .code-item {
        flex: 1;
        width: 20px;
        line-height: 30px;
        text-align: center;
        margin: 0 10px;
        background: transparent;
        border-bottom: 1px solid #E6E6E6;
        outline: none;
        font-size: 24px;
        font-weight: 700;
    }

    .code-item.code-password {
      position: relative;
    }

    .code-item.code-password::after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 6px;
      height: 6px;
      background: #000000;
      border-radius: 50%;
    }
  }
}
</style>
